import { useBackendProps } from "@/react/providers/AppContext";
import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";
import { useTailwindLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";

export const useIsAppBarVisible = () => {
  const isLargeScreen = useTailwindLgScreenMediaQuery();
  const isIframeEmbed = useIsIframeEmbed();
  const { display_header: shouldShowHeader, pages_app_page } =
    useBackendProps();

  // If it's on a custom page, and the header is hidden, we don't want to show the app bar
  const shouldHideAppBarForPagesApp = pages_app_page && !shouldShowHeader;

  return !isLargeScreen && !isIframeEmbed && !shouldHideAppBarForPagesApp;
};
